import { AddToHome, Callout } from "../components";
import { Col, Content } from "../lib";
import { browser } from "../services/browser";

export function InstallScreen() {
  if (!browser.installable) {
    return (
      <Callout
        icon="laptop-off"
        title="Not available on desktop"
        message="Smooci app is only available on mobile devices"
      />
    );
  }

  if (browser.operatingSystem === "iOS" && browser.name !== "Safari") {
    return (
      <Callout
        icon="apple-safari"
        title="Safari required"
        message="Please use Safari to install the Smooci app"
      />
    );
  }

  return (
    <Content>
      <Callout
        icon="cellphone-arrow-down"
        title="Install Smooci app"
        message="Add Smooci to your Home Screen for a better experience"
      >
        <Col mt="6">
          <AddToHome />
        </Col>
      </Callout>
    </Content>
  );
}
